import React from 'react';
import FileImportIndex from './components/FileImportIndex.jsx';

const FileImport = () => <FileImportIndex />;

export default FileImport;
